/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductClaimConversation
 */
export interface ProductClaimConversation {
    /**
     * 
     * @type {string}
     * @memberof ProductClaimConversation
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProductClaimConversation
     */
    body: string;
    /**
     * 
     * @type {string}
     * @memberof ProductClaimConversation
     */
    fromEmail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductClaimConversation
     */
    toEmails: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof ProductClaimConversation
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ProductClaimConversation
     */
    updatedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ProductClaimConversation
     */
    lastEditedAt?: Date;
}

/**
 * Check if a given object implements the ProductClaimConversation interface.
 */
export function instanceOfProductClaimConversation(value: object): value is ProductClaimConversation {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('body' in value) || value['body'] === undefined) return false;
    if (!('toEmails' in value) || value['toEmails'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ProductClaimConversationFromJSON(json: any): ProductClaimConversation {
    return ProductClaimConversationFromJSONTyped(json, false);
}

export function ProductClaimConversationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductClaimConversation {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'body': json['body'],
        'fromEmail': json['from_email'] == null ? undefined : json['from_email'],
        'toEmails': json['to_emails'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
        'lastEditedAt': json['last_edited_at'] == null ? undefined : (new Date(json['last_edited_at'])),
    };
}

export function ProductClaimConversationToJSON(json: any): ProductClaimConversation {
    return ProductClaimConversationToJSONTyped(json, false);
}

export function ProductClaimConversationToJSONTyped(value?: ProductClaimConversation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'body': value['body'],
        'from_email': value['fromEmail'],
        'to_emails': value['toEmails'],
        'created_at': value['createdAt'].toISOString(),
        'updated_at': value['updatedAt'].toISOString(),
        'last_edited_at': value['lastEditedAt'] == null ? value['lastEditedAt'] : value['lastEditedAt'].toISOString(),
    };
}

